export default __webpack_public_path__ + "assets/svg/dumbell_white.fe96ef13ee849eafd5dfa5ec8e46c00d.svg";